import React from "react";
import {
    DefaultButton,
    Stack,
    Separator,
    ActionButton,
} from "@fluentui/react";
import PrimaryButton from "../../../../Forms/PrimaryButton";

export const NavigationalButtons = ({
    onDeleteHandler,
    onDeleteProps,
    onNextHandler,
    onNextProps,
    onPrevHandler,
    onPrevProps,
    width,
    loading,
}) => {
    const showPrevious = onPrevHandler || onPrevProps;
    return (
        <>
            <Separator />
            <Stack
                horizontal
                styles={{
                    root: {
                        height: 50,
                        ...(width && { width }),
                    },
                }}
                horizontalAlign={showPrevious ? "space-between" : "end"}
                verticalAlign="center"
            >
                {showPrevious && (
                    <DefaultButton disabled={loading} onClick={onPrevHandler} {...onPrevProps}>
                        {(onPrevProps && onPrevProps.text) || "Prev"}
                    </DefaultButton>
                )}
                <Stack horizontal verticalAlign="center">
                    {onDeleteHandler && (
                        <ActionButton
                            disabled={loading}
                            iconProps={{ iconName: "Delete" }}
                            onClick={onDeleteHandler}
                            {...onDeleteProps}
                            text="Delete"
                        />
                    )}
                    <PrimaryButton
                        text={(onNextProps && onNextProps.text) || "Next"}
                        loading={loading}
                        onClick={onNextHandler}
                        {...onNextProps}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default NavigationalButtons;
